// Material Kit 2 React pages
import Ecommerce from "pages/LandingPages/Ecommerce";

export default function EcommercePage() {
  return <Ecommerce />;
}
